import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'emptyValue'
})
export class EmptyValuePipe implements PipeTransform {
  DEFAULT_EMPTY = 'N/A';
  transform(value: any, ...args: any[]): unknown {
    return value || args[0] || this.DEFAULT_EMPTY;
  }
}
